function runConfetti(...args) {
  if (typeof window.confetti === 'function') {
    return window.confetti(...args);
  } else {
    console.error('Canvas confetti is not available');
    return Promise.reject('Canvas confetti is not available');
  }
}

export default runConfetti;
